var app_html = null;
(function($) {
	/**
	 * Generates the html for the app!
	 * @param {Object} _settings
	 * @returns {app_html}
	 */
	app_html = function(_settings) {
		var self = this;
		self.settings = _settings;

		self.characters = [
      "Eneboligtomt",
    //   "Tomannsbolig",
      "Rekkehus 3 enheter",
      "Rekkehus 4 enheter",
    ];

		self.gethtml = function() {
			var html = "";
			html += '<div id="b-container">';
			html += '<div id="b-innercontainer">';
			html += '<div id="b-appcontent" style="display:none;">';
			html += '<div id="b-theapp">';

			html += '<div class="views">';

			html +=
				'<svg id="svg" viewBox="0 0 ' +
				self.settings.width +
				" " +
				self.settings.height +
				'" preserveAspectRatio="xMidYMid"></svg>';
			html += '<div id="hoverpop"></div>';

			for (var k = 1; k < self.settings.views + 1; k++) {
				html += '<div class="view" id="view' + k + '" style="display:none;">';
				html += "</div>";
			}

			//VIews
			html += "</div>";

			if (self.settings.views > 1) {
				html += '<div class="changeView">';
			} else {
				html += '<div class="changeView" style="display:none!important;">';
			}
			for (var i = 1; i < self.settings.views + 1; i++) {
				var visibleOn = "0";

				switch (i) {
					case 1:
					case 2:
						visibleOn = "1,2";
						break;
				}

				if (
					self.settings.view_names &&
					typeof self.settings.view_names[i] !== "undefined"
				) {
					html +=
						'<a href="javascript:;" id="changeView' +
						i +
						'" data-id="' +
						(i - 1) +
						'" data-rid="' +
						i +
						'" data-visible="' +
						visibleOn +
						'" class="item' +
						(i === 9999 ? " overview" : "") +
						'">' +
						self.settings.view_names[i] +
						"</a>";
				} else {
					html +=
						'<a href="javascript:;" id="changeView' +
						i +
						'" data-id="' +
						(i - 1) +
						'" data-rid="' +
						i +
						'" data-visible="' +
						visibleOn +
						'" class="item' +
						(i === 9999 ? " overview" : "") +
						'">Vinkel ' +
						i +
						"</a>";
				}
			}

			// html +=
			// 	'<a href="javascript:;" data-rid="1" data-id="1" data-visible="1">Vy 1</a>';
			// html +=
			// 	'<a href="javascript:;" data-rid="2" data-id="2" data-visible="1">Vy 2</a>';
 
			/**
			 * Link to sun study
			 */
			if (self.settings.theme === "aromalund") {
				html +=
					'<a class="external" target="_blank" href="https://aromalund.se/solstudie/">Solstudie</a>';
			}

			html += '<div class="showall-container">';

			// html += '<label class="hidesold">';
			// html += '<input type="checkbox" id="hidesold" name="hidesold"><span class="slider"></span><span class="label">Skjult solgt</span>';
			// html += "</label>";

			html += '<label class="showall">';
			html +=
				'<input type="checkbox" id="showAll" name="showAll"><span class="slider"></span><span class="label">Vis alle objekter</span>';
			html += "</label>";
			html += "</div>"; 

			html += "</div>";  

			

			

			html += '<div id="controls-wrapper">';

			if (self.settings.theme === "link_theme") {
				html += '<div id="info_title">';
				html += "<h3>Bostäder och Priser:</h4>";
				html += "</div>";
			}

			html += '<div id="controls">';
			// html += '<div id="colors">';
			// html += '<div class="ledig"><span></span>Ledig</div>';
			// html += '<div class="reserverad"><span></span>Reserverad</div>';
			// html += '<div class="sald"><span></span>Såld</div>';
			// if (self.settings.info) {
			//     html += '<div class="info"><span></span>Information</div>';
			// }
			// html += '</div>';

			html += '<div id="sliders">';

			html += '<div id="sliderRoom" class="slider">';
			html +=
				'<p><label for="room">Rom</label><input type="text" disabled="disabled" id="roomet"></p>';
			html += '<div id="sliderRum"></div>';
			html += "</div>";

			html += '<div id="sliderPris" class="slider">';
			html +=
				'<p><label for="price">Pris</label><input type="text" disabled="disabled" id="price"></p>';
			html += '<div id="sliderPrice"></div>';
			html += "</div>";

			html += '<div id="sliderBoArea" class="slider">';
			html +=
				'<p><label for="boarea">Boareal</label><input type="text" disabled="disabled" id="boarea"></p>';
			html += '<div id="sliderBo"></div>';

			html += "</div>";

			//Sliders
			html += "</div>";

			//Only AromaLund
			if (
        self.settings.theme === "husoy" ||
        self.settings.theme === "strandholmen" ||
        self.settings.theme === "elvebruket"
      ) {
        html += '<div id="characterSelect">';
        // html += '<h3>Karaktär:</h3>';
        $.each(self.characters, function (index, key) {
          html +=
            '<div class="character"><input type="checkbox" name="character[]" value="' +
            key +
            '" checked="checked"/><label>' +
            key +
            "</label></div>";
        });
        html += "</div>";

        // html += '<div id="forsalesold">';
        // html += '<div class="forsalesold"><input type="checkbox" name="forsalesold[]" value="available" checked="checked"/><label>Ledige</label></div>';
        // html += '<div class="forsalesold"><input type="checkbox" name="forsalesold[]" value="sold" /><label>Solgt</label></div>';
        // html += "</div>";

        /**
         * Switch between table and list view
         */
        html += '<div id="switch-card">';
        html += '<span class="active" id="list">Listevisning</span>';
        html += '<span id="card">Kortvisning</span>';
        html += "</div>";
      }

			//html += '<div class="clearall"></div>';

			//Controls
			html += "</div>";
			html += "</div>";
			//BTheApp
			html += "</div>";
			//BAppContent
			html += "</div>";
			//BInnerContainer
			html += "</div>";
			//BContainer
			html += "</div>";

			return html;
		};

		return self;
	};
})(jQuery);
